import * as React from "react";

interface IProps {
    icon?: any;
    superTitle?: any;
    titleText: string;
    subtitle?: string;
}

class Title extends React.Component<IProps> {
    public render() {
        const {
            titleText, superTitle, icon, subtitle,
        } = this.props;
        // This only supports numbers 1-4 which is all we need for now
        const ordinalString = (n: any) => (typeof n === "number"
            ? `${(
                ["first", "second", "third"][
                    ((((n + 90) % 100) - 10) % 10) - 1
                ] || "fourth"
            ).toLocaleUpperCase()} FLOOR`
            : n);

        let internalTitleText = "";
        if (titleText !== undefined) {
            internalTitleText = titleText;
        }

        return (
            <div className="Title">
                {superTitle && (
                    <h5 className="supertitle-text">
                        {ordinalString(superTitle)}
                    </h5>
                )}
                <h3 className="title-text">{internalTitleText}</h3>
                {icon && (
                    <div className="icon">{icon}</div>
                )}
                <p className="subtitle-text">{subtitle}</p>
            </div>
        );
    }
}

export default Title;
